/**
 * Normalize PEM content - convert literal \n strings to actual newlines.
 * Useful when PEM certificates are passed through JSON or environment variables.
 * Handles both single-escaped (\n) and double-escaped (\\n) newlines.
 */
export function normalizePem(input: string): string {
  return input
    .replace(/\\\\n/g, "\n") // Handle double-escaped \\n first
    .replace(/\\n/g, "\n") // Then handle single-escaped \n
    .trim();
}

/**
 * Validates if a string is a valid base64-encoded PEM key.
 * Checks that the decoded content contains PEM headers.
 */
export function isValidBase64Pem(value: string): boolean {
  if (!value) return false;
  try {
    const decoded = Buffer.from(value, "base64").toString(
      "utf-8"
    );
    return (
      decoded.includes("-----BEGIN") &&
      decoded.includes("-----END")
    );
  } catch {
    return false;
  }
}

/**
 * Decode a base64-encoded PEM key to its original format.
 * Returns empty string if decoding fails.
 */
export function decodeBase64Pem(base64Key: string): string {
  if (!base64Key) return "";
  try {
    return Buffer.from(base64Key, "base64").toString(
      "utf-8"
    );
  } catch {
    return "";
  }
}
